<svelte:body on:item={put_item} on:reset={() => {files = ''; comment.set('');}} />
<script>
    import _ from 'lodash';
    import { onMount } from 'svelte';
    import {map} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from "../../../config";
    import FileUpload from "../../parts/FileUpload.svelte";


    let files = ''
    const dispatch = createEventDispatcher();
    const user = store('credential', 'getAuth');
    const bracingFixed = ['ПС', 'ФЗ', 'СР', 'ПСМ', 'КС', 'Л-10'];
    const bracingPriceName = {
        'ПС': 'Оцинкованная поворотная скоба',
        'ФЗ': 'Французская скоба бронза',
        'СР': 'Скоба ремень 27х17 белая',
        'Л-10': 'Люверсы 10 мм',
    };
    const filmExtra = ['Скрин белый', 'Скрин коричневый', 'Скрин бежевый', 'Скрин серый', 'Тонировка 30%', 'Тонировка 50%'];

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;
    
        if (item) {
            const titleBody = item.title.slice(item.title.indexOf('-') + 1).split(',');
            [
                film_color, film_size, edging_color,
                padding_left,
                bracing_top, bracing_step, edging_top, width_top,
                padding_right,
                height_left, edging_left, bracing_left,
                height_right, edging_right, bracing_right, bracing_step_lr,
                width_bottom, edging_bottom, bracing_bottom, bracing_step_bottom,
                edging_skirt, entry_group, entry_count,
                pocket, garter
            ] = titleBody;
            restored = true;
            pad_top = titleBody[25] || '0';
            pad_btm = titleBody[26] || '0';
            nap_top_l = titleBody[27] || 0;
            nap_top_r = titleBody[28] || 0;
            nap_left = titleBody[29] || 0;
            nap_right = titleBody[30] || 0;
            nap_btm_l = titleBody[31] || 0;
            nap_btm_r = titleBody[32] || 0;
            lameli = titleBody[33] || 0;

            pocket = (pocket === 'с карманом' ? '1' : '0');
            garter = (garter === 'с подв.ремнями' ? '1' : '0');
            count.set(+item.quantity);
            if (item.comment.includes('Фото:')) {
                let buf = item.comment.split('Фото:')

                files = buf[1]
                comment.set(buf[0]);
            } else {
                comment.set(item.comment);
            }

            change();
        }
    };
    
    const fetchData = (async () => {
        let result = await network.fetch_data('Мягкие окна');
        
        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            result,
        }
    })();
    
    let
        // плёнка
        film_color = 'Прозрачный',
        film_size = '700 мкр',
        
        // отступы
        padding_left = 0,
        padding_right = 0,
        
        // ширины и высоты
        width_top = 1890,
        height_left = 2640,
        height_right = 2640,
        width_bottom = 1890,
        
        // крепления
        bracing_top = 'Люверсы 10 мм',
        bracing_left = 'Скоба полиамид коричневая',
        bracing_right = 'Скоба полиамид коричневая',
        bracing_bottom = 'Нет',
        bracing_step = '350',
        bracing_step_bottom = '600',
        bracing_step_lr = '440',

        // окантовка и её цвет, юбка
        edging_top = '50',
        edging_left = '50',
        edging_right = '50',
        edging_bottom = '80',
        edging_color = 'Коричневый глянец',
        edging_skirt = '0',
        
        // входная группа, карман и ремень
        entry_count = '1',
        entry_group = 'Нет',
        pocket = '1',
        garter = '1',

        pad_top = '0',
        pad_btm = '0',

        // напайки и ламели, только склад 18
        nap_top_l = 0,
        nap_top_r = 0,
        nap_left = 0,
        nap_right = 0,
        nap_btm_l = 0,
        nap_btm_r = 0,
        lameli = 0,
        restored = false,
    
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    $: sklad18 = APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 18;
    $: if (sklad18 && !restored && bracing_top === 'Люверсы 10 мм') {
        bracing_top = 'Л-10';
        bracing_left = 'ПС';
        bracing_right = 'ПС';
    }

    const filmOptions = (data) => {
        const films = _.uniqBy(data.name['Пленка'] || [], 'ind2').map((item) => item.ind2);
        if (!sklad18) {
            return films;
        }
        return _.uniq(films.filter((name) => String(name).toLowerCase() !== 'сетка').concat(filmExtra));
    };

    const bracingHit = (selected, entry) => {
        const name = sklad18 && bracingPriceName[selected] ? bracingPriceName[selected] : selected;
        return sklad18 ? name === entry : String(selected).includes(entry);
    };

    const changePocket = () => {
        if (+pocket) {
            bracing_bottom = 'Нет';
        }
    };
    const changeTopSide = () => width_bottom = width_top;
    const changeBottomSide = () => {
        if (!sklad18) {
            padding_left = width_bottom > width_top ? width_bottom - width_top : 0;
        }
    };
    const changePaddingLeft = () => {
        if (!sklad18) {
            padding_right = width_bottom - width_top - padding_left;
        }
    };
    const changeLeftSide = () => height_right = height_left;

    const changeLeftSideBracing = () => bracing_right = bracing_left;
    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    // расчёт стоимости
    const change = (async () => {
        let data = await fetchData;
        
        let
            quantity = +$count,
            
            shag = bracing_step,
            shag_bottom = bracing_step_bottom,
            shag_lr = bracing_step_lr,
            wt = +width_top,
            wb = +width_bottom,
            hl = +height_left,
            hr = +height_right,
    
            wtol = +padding_left,
            wtor = +padding_right,
    
            ot = +edging_top,
            ob = +edging_bottom,
            ol = +edging_left,
            or = +edging_right,
    
            kt = bracing_top,
            kb = bracing_bottom,
            kl = bracing_left,
            kr = bracing_right,
    
            vg = entry_group.toLowerCase(),
            kvg = +entry_count,
            
            karman = +pocket,
            podvyaz = +garter,
            yobka = +edging_skirt ?? 0,
            
            krep = _.map(data.ind1['Крепление'], 'name')
        ;
        if (sklad18) {
            const extraW = Math.max(0, wb - wt);
            wtol = Math.floor(extraW / 2);
            wtor = extraW - wtol;
            krep = _.uniq(krep.concat(bracingFixed));
        }

        let dimensions = [width_top, height_right, width_bottom, height_left].join('x');
        let result = {
            type: 'мягкие-окна',
            name: 'Мягкие окна',
            subname: [
                film_color, ',' + (film_color.toLowerCase() === 'сетка' ? '' : film_size), ',' + edging_color,
                ',' + padding_left,
                ',' + bracing_top, ',' + shag, ',' + edging_top, ',' + width_top,
                ',' + padding_right,
                ',' + height_left, ',' + edging_left, ',' + bracing_left,
                ',' + height_right, ',' + edging_right, ',' + bracing_right, ',' + shag_lr,
                ',' + width_bottom, ',' + edging_bottom, ',' + bracing_bottom, ',' + shag_bottom,
                ',' + edging_skirt ?? '0', ',' + entry_group, ',' + entry_count,
                ',' + (karman ? 'с карманом' : 'без кармана'),
                ',' + (podvyaz ? 'с подв.ремнями' : 'без подв.ремней'),
                ',' + pad_top,
                ',' + pad_btm,
                ',' + nap_top_l,
                ',' + nap_top_r,
                ',' + nap_left,
                ',' + nap_right,
                ',' + nap_btm_l,
                ',' + nap_btm_r,
                ',' + lameli,
            ].join(''),
            title: [
                'Мягкие окна',
                '-' + film_color, ',' + (film_color.toLowerCase() === 'сетка' ? '' : film_size), ',' + edging_color,
                ',' + padding_left,
                ',' + bracing_top, ',' + shag, ',' + edging_top, ',' + width_top,
                ',' + padding_right,
                ',' + height_left, ',' + edging_left, ',' + bracing_left,
                ',' + height_right, ',' + edging_right, ',' + bracing_right, ',' + shag_lr,
                ',' + width_bottom, ',' + edging_bottom, ',' + bracing_bottom, ',' + shag_bottom,
                ',' + edging_skirt ?? '0', ',' + entry_group, ',' + entry_count,
                ',' + (karman ? 'с карманом' : 'без кармана'),
                ',' + (podvyaz ? 'с подв.ремнями' : 'без подв.ремней'),
                ',' + pad_top,
                ',' + pad_btm,
                ',' + nap_top_l,
                ',' + nap_top_r,
                ',' + nap_left,
                ',' + nap_right,
                ',' + nap_btm_l,
                ',' + nap_btm_r,
                ',' + lameli,
            ].join(''),
            params: {
                ind1: dimensions,
                ind2: edging_color,
                ind3: [
                    film_color, ',' + (film_color.toLowerCase() === 'сетка' ? '' : film_size), ',' + edging_color,
                    ',' + padding_left,
                    ',' + bracing_top, ',' + shag, ',' + edging_top,
                    ',' + padding_right,
                    ',' + edging_left, ',' + bracing_left,
                    ',' + edging_right, ',' + bracing_right, ',' + shag_lr,
                    ',' + edging_bottom, ',' + bracing_bottom, ',' + shag_bottom,
                    ',' + edging_skirt ?? '0', ',' + entry_group, ',' + entry_count,
                    ',' + (karman ? 'с карманом' : 'без кармана'),
                    ',' + (podvyaz ? 'с подв.ремнями' : 'без подв.ремней'),
                    ',' + pad_top,
                    ',' + pad_btm,
                    ',' + nap_top_l,
                    ',' + nap_top_r,
                    ',' + nap_left,
                    ',' + nap_right,
                    ',' + nap_btm_l,
                    ',' + nap_btm_r,
                    ',' + lameli,
                ].join(''),
                ind4: '',
                ind5: '',
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: `${$comment} ${files.length ? `Фото:${files}` : ''}`.trim(),
            vStrukture: 34,
        };
        
        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();
            
            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            
            if (name.includes('окантовка') && item.ind2 === edging_color) {
                kolvo = kolvo + ((wt + 150) * ot * 2) / 1000000;
                kolvo = kolvo + ((wb + 150) * ob * 2) / 1000000;
    
                if ((wtol === 0) && (wtor === 0)) {
                    kolvo = kolvo + ((hl + 150) * ol * 2) / 1000000;
                    kolvo = kolvo + ((hr + 150) * or * 2) / 1000000;
                } else {
                    if (wtol === 0) {
                        kolvo = kolvo + ((hl + 150) * ol * 2) / 1000000;
                    } else {
                        kolvo = kolvo + (Math.sqrt(Math.pow((hl + 150), 2) + Math.pow(wtol, 2)) * ol * 2) / 1000000;
                    }
        
                    if (wtor === 0) {
                        kolvo = kolvo + ((hr + 150) * or * 2) / 1000000;
                    } else {
                        kolvo = kolvo + (Math.sqrt(Math.pow((hr + 150), 2) + Math.pow(wtor, 2)) * or * 2) / 1000000;
                    }
                }
    
                if (yobka > 0) {
                    kolvo = kolvo + ((wb + 150) * (yobka + 50)) / 1000000;
                }
                if (podvyaz === 1) {
                    let kolvoTemp = Math.ceil(Math.max(wt, wb) / 1000);
                    if (kolvoTemp <2 ) {
                        kolvoTemp = 2;
                    };

                    kolvo = kolvo + kolvoTemp  * 20 * 2000 / 1000000;
                }


                if (vg === 'молния') {
                    kolvo = kolvo +  (Math.max(hr, hl)  * 220) * kvg / 1000000;
                }
            }
            
            const colorKey = film_color.toLowerCase();
            const extraFilm = filmExtra.some((name) => name.toLowerCase() === colorKey);
            if (
                (name.includes('пленка') || (extraFilm && (name.includes(colorKey) || (item.ind2 || '').toLowerCase().includes(colorKey)))) &&
                (item.ind2 || '').toLowerCase().includes(colorKey) &&
                (extraFilm || item.ind1.toLowerCase().includes(film_size.toLowerCase()))
            ) {
                let vgo = 0;
    
                if (vg === 'молния') {
                    vgo = kvg * 110
                }
                if ((wt - or + 30 - ol + 30) === (wb - or + 30 - ol + 30) && (hr - ot + 30 - ob + 30) === (hl - ot + 30 - ob + 30)) {
                    kolvo = (wt - or + 30 - ol + 30 - vgo) * (hr - ot + 30 - ob + 30) / 1000000;
                } else {
                    kolvo = Math.max((wt - or + 30 - ol + 30 - vgo), (wb - or + 30 - ol + 30 - vgo)) * Math.max((hr - ot + 30 - ob + 30), (hl - ot + 30 - ob + 30)) / 1000000;
                }
            }

            if (
                name.includes('сетка') &&
                film_color.toLowerCase() === 'сетка'
            ) {
                let vgo = 0;

                if ((wt - or + 30 - ol + 30) === (wb - or + 30 - ol + 30) && (hr - ot + 30 - ob + 30) === (hl - ot + 30 - ob + 30)) {
                    kolvo = (wt - or + 30 - ol + 30 - vgo) * (hr - ot + 30 - ob + 30) / 1000000;
                } else {
                    kolvo = Math.max((wt - or + 30 - ol + 30 - vgo), (wb - or + 30 - ol + 30 - vgo)) * Math.max((hr - ot + 30 - ob + 30), (hl - ot + 30 - ob + 30)) / 1000000;
                }
            }

    
            if (vg === 'молния') {
                if (name.includes('молния')) {
                    if (Math.max(hr, hl)<2500){
                        kolvo= 2000;
                    }
                    else{
                        kolvo= 3000;
                    }

                    kolvo = kolvo / 1000 * kvg;
                }
                if (name.includes('замок')) {
                    kolvo = kvg;
                }
                if (name.includes('спайка')) {
                    kolvo = Math.ceil(Math.max(hr, hl))
                    kolvo = kolvo / 1000 * kvg;
                }
            }
            else if (vg === 'магнит') {
                if (name.includes('магнит')) {
                    kolvo = Math.ceil(Math.max(hr, hl) / 200);
                    kolvo = kvg * kolvo;
                }
            }

            if ( name.includes('фастекс')) {
                if (podvyaz === 1) {
                    kolvo = Math.ceil(Math.max(wt, wb) / 1000);
                    if (kolvo < 2) {
                        kolvo = 2;
                    }
                }
            }
    
            _.forEach(krep, (entry) => {
                if (item.name === entry) {
                    if (bracingHit(kt, entry)) { kolvo = kolvo + (Math.floor(wt / shag) + 1); }
                    if (bracingHit(kr, entry)) { kolvo = kolvo + (Math.floor(hr / shag_lr) + 1); }
                    if (bracingHit(kb, entry)) { kolvo = kolvo + (Math.floor(wb / shag_lr) + 1); }
                    if (bracingHit(kl, entry)) { kolvo = kolvo + (Math.floor(hl / shag_bottom) + 1); }
                }
            });
    
            if (name === 'сборка') {
                kolvo = Math.max(wt, wb) * Math.max(hr, hl) / 1000000;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);
    
                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    quantity,
                    price,
                    count: (+kolvo).toFixed(3)
                };
            }
        });
        
        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('mounting', {
            list: _.filter(data.result, (el) => el.name.toLowerCase().startsWith('монтаж')),
            kv: Math.max(wt , wb) * Math.max(hr, hl) / 1000000,
            quantity
        });
        dispatch('item', result);
        draw();
    });

    change();
    
    // функция отрисовки изображения изделия
    const draw = () => {
        let c = document.getElementById('item-view');

        if (c) {
            if (sklad18 && !(c.clientWidth > 0 && c.clientHeight > 0)) {
                setTimeout(draw, 50);
                return;
            }
            if (sklad18) {
                const cssW = Math.round(c.clientWidth);
                const cssH = Math.round(c.clientHeight);
                if (c.width !== cssW || c.height !== cssH) {
                    c.width = cssW;
                    c.height = cssH;
                }
            }
            let ctx = c.getContext('2d');

            let slantLeft = +padding_left;
            let slantRight = +padding_right;
            if (sklad18) {
                const extraW = Math.max(0, +width_bottom - +width_top);
                slantLeft = Math.floor(extraW / 2);
                slantRight = extraW - slantLeft;
            }

            let width = c.width,
                height = c.height,
                fit = 0;
            if (sklad18) {
                const contentW = Math.max(+width_top + slantLeft + slantRight, +width_bottom, 1);
                const contentH = Math.max(+height_left, +height_right, 1);
                fit = Math.min(width / contentW, height / contentH) * 0.92;
            }
            const px = (mm, horizontal) => sklad18
                ? +mm * fit
                : map(mm, 0, 5000, 0, horizontal ? width : height);
            let pl = px(slantLeft, true),
                pr = px(slantRight, true),
                top = px(width_top, true),
                right = px(height_right, false),
                bottom = px(width_bottom, true),
                left = px(height_left, false);

            if (!sklad18 && top >= bottom) {
                padding_left = padding_right = pl = pr = 0;
            }

            // clear
            ctx.clearRect(0, 0, width, height);

            const ax0 = (width - (top + pl + pr)) / 2;
            const bx0 = ax0 + (top + pl + pr);
            const dx0 = (width - bottom) / 2;
            const cx0 = dx0 + bottom;
            let ay0 = (height - left) / 2;
            let by0 = (height - right) / 2;
            let dy0 = ay0 + left;
            let cy0 = by0 + right;
            if (sklad18) {
                const floor = (height + Math.max(left, right)) / 2;
                dy0 = cy0 = floor;
                ay0 = floor - left;
                by0 = floor - right;
            }

            // draw trapezoid
            ctx.beginPath();
            ctx.moveTo(ax0, ay0); // A
            ctx.lineTo(bx0, by0); // B
            ctx.lineTo(cx0, cy0); // C
            ctx.lineTo(dx0, dy0); // D
            ctx.closePath();
            ctx.strokeStyle = 'black';
            ctx.stroke();

            // draw left padding
            if (pl) {
                ctx.beginPath();
                ctx.moveTo(ax0 + pl, ay0);
                ctx.lineTo(ax0, ay0);
                ctx.lineTo(dx0, dy0);
                ctx.closePath();
                ctx.stroke();
                ctx.fillStyle = 'gray';
                ctx.fill();
            }

            // draw right padding
            if (pr) {
                ctx.beginPath();
                ctx.moveTo(bx0 - pr, by0);
                ctx.lineTo(bx0, by0);
                ctx.lineTo(cx0, cy0);
                ctx.closePath();
                ctx.stroke();
                ctx.fillStyle = 'gray';
                ctx.fill();
            }

            const corner = (x, y, wMm, hMm, toLeft, toUp) => {
                const w = px(wMm, true);
                const h = px(hMm, false);
                if (!(w > 0 && h > 0)) {
                    return;
                }
                const x0 = toLeft ? x - w : x;
                const y0 = toUp ? y - h : y;
                ctx.strokeRect(x0, y0, w, h);
            };
            if (sklad18) {
                corner(ax0, ay0, padding_left, nap_top_l, false, false);
                corner(bx0, by0, padding_right, nap_top_r, true, false);
                corner(dx0, dy0, nap_left, nap_btm_l, false, true);
                corner(cx0, cy0, nap_right, nap_btm_r, true, true);
            }

            if (+lameli) {
                const y = ((dy0 + cy0) / 2) - px(lameli, false);
                ctx.beginPath();
                ctx.moveTo(Math.min(ax0, dx0), y);
                ctx.lineTo(Math.max(bx0, cx0), y);
                ctx.stroke();
                ctx.fillStyle = 'black';
                ctx.font = '12px sans-serif';
                ctx.fillText(String(lameli), width / 2 - 14, y - 2);
            }
        } else {
            setTimeout(draw, 500);
        }
    };

    onMount(() => draw());
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        {#if sklad18}
        <div class="row">
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип материала</label>
                        <select class="form-control form-select" bind:value={film_color}>
                            {#each filmOptions(data) as item}
                                <option value="{item}">{item}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление сверху</label>
                        <select class="form-control form-select" bind:value={bracing_top}>
                            <option value="Нет">Нет</option>
                            {#each bracingFixed as item}
                                <option value="{item}">{item}</option>
                            {/each}
                            {#if bracing_top !== 'Нет' && bracingFixed.indexOf(bracing_top) === -1}
                                <option value="{bracing_top}">{bracing_top}</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет окантовки</label>
                        <select class="form-control form-select" bind:value={edging_color}>
                            {#each data.name['Окантовка'] as item}
                                <option value="{item.ind2}">{item.ind2}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Кол-во и вход.группа</label>
                        <div class="input-group">
                            <input type="number" class="form-control" min="1" bind:value={entry_count} use:validate_int={entry_count}>
                            <select class="form-control form-select" bind:value={entry_group}>
                                <option value="Нет">Нет</option>
                                <option value="Молния">Молния</option>
                                <option value="Магнит">Магнит</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка сверху</label>
                        <input type="number" class="form-control" bind:value={edging_top}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ сверху л</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_top_l} use:validate_int={nap_top_l}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина верх</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={width_top} on:change={changeTopSide} use:validate_int={width_top} on:keyup={changeTopSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ сверху п</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_top_r} use:validate_int={nap_top_r}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота слева</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={height_left} on:change={changeLeftSide} use:validate_int={height_left} on:keyup={changeLeftSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота справа</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={height_right} on:change={draw} use:validate_int={height_right} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ слева</label>
                        <input type="number" class="form-control" min="0" bind:value={padding_left} on:change={changePaddingLeft} use:validate_int={padding_left} on:keyup={changePaddingLeft} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ справа</label>
                        <input type="number" class="form-control" min="0" bind:value={padding_right} on:change={draw} use:validate_int={padding_right} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка слева</label>
                        <input type="number" class="form-control" bind:value={edging_left}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка справа</label>
                        <input type="number" class="form-control" bind:value={edging_right}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <canvas id="item-view" style="width: 100%; height: 480px; display: block; margin-bottom: 12px; border:1px solid #ced4da; border-radius: 6px;"></canvas>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление слева</label>
                        <select class="form-control form-select" bind:value={bracing_left} on:change={changeLeftSideBracing} on:keyup={changeLeftSideBracing}>
                            <option value="Нет">Нет</option>
                            {#each bracingFixed as item}
                                <option value="{item}">{item}</option>
                            {/each}
                            {#if bracing_left !== 'Нет' && bracingFixed.indexOf(bracing_left) === -1}
                                <option value="{bracing_left}">{bracing_left}</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление справа</label>
                        <select class="form-control form-select" bind:value={bracing_right}>
                            <option value="Нет">Нет</option>
                            {#each bracingFixed as item}
                                <option value="{item}">{item}</option>
                            {/each}
                            {#if bracing_right !== 'Нет' && bracingFixed.indexOf(bracing_right) === -1}
                                <option value="{bracing_right}">{bracing_right}</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Напайка, отступ слева</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_left} use:validate_int={nap_left}>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ низ л</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_btm_l} use:validate_int={nap_btm_l}>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ низ п</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_btm_r} use:validate_int={nap_btm_r}>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Напайка, отступ справа</label>
                        <input type="number" class="form-control" min="0" bind:value={nap_right} use:validate_int={nap_right}>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ламели, от пола</label>
                        <input type="number" class="form-control" min="0" bind:value={lameli} use:validate_int={lameli}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Юбка</label>
                        <input type="number" class="form-control" bind:value={edging_skirt}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина низ</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={width_bottom} on:change={changeBottomSide} use:validate_int={width_bottom} on:keyup={changeBottomSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка снизу</label>
                        <input type="number" class="form-control" bind:value={edging_bottom}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление снизу</label>
                        <select class="form-control form-select" bind:value={bracing_bottom} on:change={changePocket}>
                            <option value="Нет">Нет</option>
                            {#each bracingFixed as item}
                                <option value="{item}">{item}</option>
                            {/each}
                            {#if bracing_bottom !== 'Нет' && bracingFixed.indexOf(bracing_bottom) === -1}
                                <option value="{bracing_bottom}">{bracing_bottom}</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <select class="form-control form-select" style="margin-top: 21px" bind:value={pocket} on:change={changePocket}>
                            <option value="1">С карманом</option>
                            <option value="0">Без кармана</option>
                        </select>
                    </div>
                    <div class="input-wrapper">
                        <select class="form-control form-select" style="margin-top: 37px" bind:value={garter}>
                            <option value="1">С подв.ремнем</option>
                            <option value="0">Без подв.ремня</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        {:else}
        <div class="row">
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип материала</label>
                        <select class="form-control form-select" bind:value={film_color}>
                            {#each filmOptions(data) as item}
                                <option value="{item}">{item}</option>
                            {/each}
                            {#if !sklad18}
                                <option value="Сетка">Москитная сетка</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление</label>
                        <select class="form-control form-select" bind:value={bracing_top}>
                            <option value="Нет">Нет</option>
                            {#if sklad18}
                                {#each bracingFixed as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            {:else}
                                {#each data.ind1['Крепление'] as item}
                                    <option value="{item.name}">{item.name}</option>
                                {/each}
                            {/if}
                            {#if sklad18 && bracing_top !== 'Нет' && bracingFixed.indexOf(bracing_top) === -1}
                                <option value="{bracing_top}">{bracing_top}</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет окантовки</label>
                        <select class="form-control form-select" bind:value={edging_color}>
                            {#each data.name['Окантовка'] as item}
                                <option value="{item.ind2}">{item.ind2}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4  ">
                <div class="form-group boxed d-none">
                    <div class="input-wrapper">
                        <label class="form-label">Толщина</label>
                        <select class="form-control form-select" bind:value={film_size}>
                            {#each _.filter(data.name['Пленка'], {'ind2': film_color}) as item}
                                <option value="{item.ind1}">{item.ind1}</option>
                            {/each}
                        </select>
                    </div>
                </div>


                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Кол-во и вход.группа</label>
                        <div class="input-group">
                            <input type="number" class="form-control" min="1" bind:value={entry_count} use:validate_int={entry_count}>
                            <select class="form-control form-select" bind:value={entry_group}>
                                <option value="Нет">Нет</option>
                                <option value="Молния">Молния</option>
                                <option value="Магнит">Магнит</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-group boxed d-none">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>

            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка</label>
                        <input type="number" class="form-control" bind:value={edging_top}>
                    </div>
                </div>
            </div>
            <div class="col-4 d-none">
                <div class="form-group boxed d-none">
                    <div class="input-wrapper">
                        <label class="form-label">Шаг крепления верх</label>
                        <input type="number" class="form-control" bind:value={bracing_step}>
                    </div>
                </div>
            </div>

            {#if !sklad18}
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ верх</label>
                        <input type="number" class="form-control" bind:value={pad_top}>
                    </div>
                </div>
            </div>
            {:else}
            <div class="col-4"></div>
            {/if}


            <div class="col-4">
                {#if sklad18}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Отступ сверху л</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_top_l} use:validate_int={nap_top_l}>
                        </div>
                    </div>
                {/if}
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ слева</label>
                        <input type="number" class="form-control" min="0" bind:value={padding_left} on:change={changePaddingLeft} use:validate_int={padding_left} on:keyup={changePaddingLeft} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина верх</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={width_top} on:change={changeTopSide} use:validate_int={width_top} on:keyup={changeTopSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
            </div>
            <div class="col-4">
                {#if sklad18}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Отступ сверху п</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_top_r} use:validate_int={nap_top_r}>
                        </div>
                    </div>
                {/if}
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Отступ справа</label>
                        <input type="number" class="form-control" min="0" bind:value={padding_right} on:change={draw}  use:validate_int={padding_right} on:keyup={draw}>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота слева</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={height_left} on:change={changeLeftSide} use:validate_int={height_left} on:keyup={changeLeftSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка</label>
                        <input type="number" class="form-control" bind:value={edging_left}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление</label>
                        <select class="form-control form-select" bind:value={bracing_left} on:change={changeLeftSideBracing} on:keyup={changeLeftSideBracing}>
                            <option value="Нет">Нет</option>
                            {#if sklad18}
                                {#each bracingFixed as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            {:else}
                                {#each data.ind1['Крепление'] as item}
                                    <option value="{item.name}">{item.name}</option>
                                {/each}
                            {/if}
                            {#if sklad18 && bracing_left !== 'Нет' && bracingFixed.indexOf(bracing_left) === -1}
                                <option value="{bracing_left}">{bracing_left}</option>
                            {/if}
                        </select>
                    </div>
                </div>
                {#if sklad18}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Напайка, отступ слева</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_left} use:validate_int={nap_left}>
                        </div>
                    </div>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Отступ низ л</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_btm_l} use:validate_int={nap_btm_l}>
                        </div>
                    </div>
                {/if}




            </div>
            <div class="col-4">
                <canvas id="item-view" style="width: 100%; height: 100%; border:1px solid #ced4da; border-radius: 6px;"></canvas>
            </div>
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота справа</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={height_right} on:change={draw} use:validate_int={height_right} on:keyup={draw}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка</label>
                        <input type="number" class="form-control" bind:value={edging_right}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление</label>
                        <select class="form-control form-select" bind:value={bracing_right}>
                            <option value="Нет">Нет</option>
                            {#if sklad18}
                                {#each bracingFixed as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            {:else}
                                {#each data.ind1['Крепление'] as item}
                                    <option value="{item.name}">{item.name}</option>
                                {/each}
                            {/if}
                            {#if sklad18 && bracing_right !== 'Нет' && bracingFixed.indexOf(bracing_right) === -1}
                                <option value="{bracing_right}">{bracing_right}</option>
                            {/if}
                        </select>
                    </div>
                </div>

                {#if sklad18}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Отступ низ п</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_btm_r} use:validate_int={nap_btm_r}>
                        </div>
                    </div>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Напайка, отступ справа</label>
                            <input type="number" class="form-control" min="0" bind:value={nap_right} use:validate_int={nap_right}>
                        </div>
                    </div>
                {:else}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Отступ низ</label>
                            <input type="number" class="form-control" bind:value={pad_btm}>
                        </div>
                    </div>
                {/if}

                <div class="form-group boxed d-none">
                    <div class="input-wrapper">
                        <label class="form-label ">Шаг крепления</label>
                        <input type="number" class="form-control" bind:value={bracing_step_lr}>
                    </div>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-4">
                {#if sklad18}
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Ламели, от пола</label>
                            <input type="number" class="form-control" min="0" bind:value={lameli} use:validate_int={lameli}>
                        </div>
                    </div>
                {/if}
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Юбка</label>
                        <input type="number" class="form-control" bind:value={edging_skirt}>
                    </div>
                </div>
    

            </div>
            
            <div class="col-4">

                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина низ</label>
                        <input type="number" class="form-control" step="10" min="0" max="5000" bind:value={width_bottom} on:change={changeBottomSide} use:validate_int={width_bottom} on:keyup={changeBottomSide} on:change={draw} on:keyup={draw}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Окантовка</label>
                        <input type="number" class="form-control" bind:value={edging_bottom}>
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Крепление</label>
                        <select class="form-control form-select" bind:value={bracing_bottom} on:change={changePocket}>
                            <option value="Нет">Нет</option>
                            {#if sklad18}
                                {#each bracingFixed as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            {:else}
                                {#each data.ind1['Крепление'] as item}
                                    <option value="{item.name}">{item.name}</option>
                                {/each}
                            {/if}
                            {#if sklad18 && bracing_bottom !== 'Нет' && bracingFixed.indexOf(bracing_bottom) === -1}
                                <option value="{bracing_bottom}">{bracing_bottom}</option>
                            {/if}
                        </select>
                    </div>
                </div>


            </div>
            
            <div class="col-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <select class="form-control form-select" style="margin-top: 21px" bind:value={pocket} on:change={changePocket}>
                            <option value="1">С карманом</option>
                            <option value="0">Без кармана</option>
                        </select>
                    </div>
                    <div class="input-wrapper">
                        <select class="form-control form-select" style="margin-top: 37px" bind:value={garter}>
                            <option value="1">С подв.ремнем</option>
                            <option value="0">Без подв.ремня</option>
                        </select>
                    </div>

                </div>
                <div class="form-group boxed d-none">
                    <div class="input-wrapper">
                        <label class="form-label  ">Шаг крепления низ</label>
                        <input type="number" class="form-control" bind:value={bracing_step_bottom}>
                    </div>
                </div>
            </div>
        </div>
        {/if}
        
        <div class="row">
            <div class="col-12">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <FileUpload onfile={(link) => {files = link; change()}}/>

                {#if files.trim().length}
                    <div>
                        {#each files.split(';') as file, i}
                            <div class="btn-group mx-1">
                                <a href={file} class="btn btn-outline-secondary btn-icon btn-sm" target="_blank" rel="noreferrer" title="Фото #{i+1}">
                                    <img src={file} alt="Фото #{i+1}" style="width: 20px"/>
                                </a>
                                <button type="button"
                                        class="btn btn-outline-danger btn-icon btn-sm"
                                        title="RM: Фото #{i+1}"
                                        on:click={() => files = files.split(';').filter((el) => el !== file).join(';')}
                                >
                                    <i class="fas fa-trash fa-fw"></i>
                                </button>
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/await}